module.exports = __webpack_public_path__ + "static/media/franciszkanie.cf4d8954.jpg";